import { Action } from 'redux';
import { ChiamateState } from './models';
import { ChiamateActions } from './actionTypes';

const initialState: ChiamateState = {
    destinatariMatricole: { lista: [], refreshCache: true },
    tipiRichiestaRiepiloghi: { riepiloghi: { tipiRichiesta: [], chiamateAttive: []} , refreshCache: true },
    chiamateAttive: { lista: [], refreshCache: true },
    chiamate: { lista: [], page: 1, pageSize: 100, itemsCount: 0, refreshCache: true }
}

export default (
    state: ChiamateState = initialState, 
    incomingAction: Action
): ChiamateState => {
    const action = incomingAction as ChiamateActions;
    switch (action.type) {
        case 'core/MODIFICA_ANAGRAFICA':
            return initialState;
        case 'core/SAVE_ANAGRAFICHE_CUSTOM':
        case 'core/SAVE_UBICAZIONI':
            return {
                ...state,
                destinatariMatricole: { ...state.destinatariMatricole, refreshCache: true }
            }
        case 'chiamate/LOAD_DESTINATARI_MATRICOLE': 
            return { 
                ...state, 
                destinatariMatricole: { lista: action.value, refreshCache: false }
            };
        case 'chiamate/LOAD_TIPI_RICHIESTA':
            return {
                ...state,
                tipiRichiestaRiepiloghi: { riepiloghi: action.value, refreshCache: false }
            };
        case 'chiamte/LOAD_CHIAMATE':
            return {
                
                ...state,
                chiamate: { 
                    lista: action.value.results, 
                    page: action.page, 
                    pageSize: action.value.pageSize,
                    itemsCount: action.value.count, 
                    refreshCache: false 
                }
            };
        case 'chiamte/SAVE_TICKET_SUCCESS':
            return {
                ...state,
                chiamate: {
                    ...state.chiamate,
                    refreshCache: true
                }
            };

        default: return state;
    }
};